import { render, staticRenderFns } from "./templateForm.vue?vue&type=template&id=f2e87200&scoped=true&"
import script from "./templateForm.vue?vue&type=script&lang=js&"
export * from "./templateForm.vue?vue&type=script&lang=js&"
import style0 from "./templateForm.vue?vue&type=style&index=0&id=f2e87200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e87200",
  null
  
)

export default component.exports